import AbstractCalls from "./AbstractCalls";

class MastersListCalls extends AbstractCalls {
  get(body, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "mastersList/get");
    return AbstractCalls.get(cmdUri, body, options);
  }

  import(dtoIn, options) {
    const cmdUri = AbstractCalls.buildCallUri("main", "mastersList/import");
    return AbstractCalls.post(cmdUri, dtoIn, options);
  }
}

export default new MastersListCalls();
